
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/node-js",
      function () {
        return require("private-next-pages/courses/node-js.tsx");
      }
    ]);
  